import { AfterViewInit, Compiler, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './core/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'mrr-web';

  constructor(
    public translate: TranslateService,
    public configService: ConfigService,
    private compiler: Compiler
  ) {
    compiler.clearCache();
    translate.addLangs(['en', 'zh']);
    translate.setDefaultLang(localStorage.getItem('locale') || 'zh');
  }

  ngAfterViewInit(): void {
    const dateFrom = new Date('2025-01-27').getTime();
    const dateTo = new Date('2025-02-09').getTime();
    const currentDate = new Date().getTime();

    if (currentDate >= dateFrom && currentDate <= dateTo) {
      setTimeout(() => {
        const snackbar = document.getElementById('snackbar');
        if (snackbar) {
          // Add the "show" class to DIV
          snackbar.className = 'show';
          sessionStorage.setItem('displaySnackbar', new Date().getTime() + '');
          // After 5 seconds, remove the show class from DIV
          setTimeout(() => {
            snackbar.className = snackbar.className.replace('show', '');
          }, 10000);
        }
      }, 1000);
    }
  }

  closeSnackbar() {
    const snackbar = document.getElementById('snackbar');
    snackbar.className = snackbar.className.replace('show', '');
  }
}
